export class DatiVersionamentoDocumentoVO {
    versione: string;

    data: string;

    idVersionePrecedente: string;

    idVersioneSuccessiva: string;
}